import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const UpdateFamilyDetails = () => {
  const [professionopen, setProfessionopen] = React.useState(false);
  const [professionscroll, setProfessionscroll] = React.useState();

  const handleClickProfessionOpen = (scrollType) => () => {
    setProfessionopen(true);
    setProfessionscroll(scrollType);
  };

  const handleProfessionClose = () => {
    setProfessionopen(false);
  };

  const professiondescriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (professionopen) {
      const { current: descriptionElement } = professiondescriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [professionopen]);

  return (
    <div>
      <Button onClick={handleClickProfessionOpen()}>scroll=paper</Button>
      <Dialog
        open={professionopen}
        onClose={handleProfessionClose}
        scroll={professionscroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Subscribe</DialogTitle>
        <DialogContent dividers={professionscroll}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={professiondescriptionElementRef}
            tabIndex={-1}
          >
            {[...new Array(50)]
              .map(
                () => `Cras mattis consectetur purus sit amet fermentum.
Cras justo odio, dapibus ac facilisis in, egestas eget quam.
Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
Praesent commodo cursus magna, vel scelerisque nisl consectetur et.`
              )
              .join("\n")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleProfessionClose}>Subscribe</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UpdateFamilyDetails;
